import React from "react";
import Modal from "../ui/Modal";
import Button from "../ui/Button";
import { Textarea } from "../ui/Field";

const ModalComments = ({ show, setShow, comments, setComments }) => (
  <Modal
    open={!!show}
    onClose={() => setShow(false)}
    title="Σχόλια"
    footer={<Button onClick={() => setShow(false)}>Κλείσιμο</Button>}
  >
    <div className="py-1">
      <Textarea label="Σχόλια" value={comments} onChange={(e) => setComments(e.target.value)} rows={6} />
    </div>
  </Modal>
);

export default ModalComments;
